import { useWidgetContext } from '../../../context/WidgetContext';

export const MainHeader = () => {
  const { 
    agent,
  } = useWidgetContext();

  return (
    <div className='osirus-agent-main-header'>
      <div>
        {agent.companyIconUrl && (
          <img src={agent.companyIconUrl} alt={`${agent.name} logo`} />
        )}
        <h2>{ agent.companyName || agent.name}</h2>
      </div>
      {agent.description && (
        <p>{agent.description}</p>
      )}
    </div>
  )
}
